import { render } from "./domains.vue?vue&type=template&id=68b218b8&scoped=true"
import script from "./domains.vue?vue&type=script&lang=js"
export * from "./domains.vue?vue&type=script&lang=js"

import "./domains.vue?vue&type=style&index=0&id=68b218b8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b218b8"]])

export default __exports__